import { useMergedConfigStore } from 'src/stores/merged_config.js'

import { fetchFederationRestrictions } from 'src/api/federationRestrictions.js'

const FETCH_FEDERATION_RESTRICTIONS_INTERVAL_MS = 1000 * 60 * 60

const evaluate = (r, { domains, age }) =>
  !domains.includes(r.instance) &&
  (isNaN(age) ||
    (Date.now() - new Date(r.last_seen).getTime()) / 86400000 < age)

const comparator = (a, b) => b.active - a.active

export const defaultState = {
  restrictions: {},
  fetchFederationRestrictionsTimer: undefined,
}

export const mutations = {
  setFederationRestrictions(state, restrictions) {
    state.restrictions = restrictions
  },
  evaluateFederationRestrictions(state, whitelist) {
    for (const k in state.restrictions) {
      for (const r of state.restrictions[k]) {
        r.active = evaluate(r, whitelist)
      }
      state.restrictions[k].sort(comparator)
    }
  },
  setFetchFederationRestrictionsTimer(state, timer) {
    state.fetchFederationRestrictionsTimer = timer
  },
}

export const getters = {
  findFederationRestrictions: (state) => (id) => {
    return state.restrictions[id] || []
  },
}

const federationRestrictions = {
  state: defaultState,
  mutations,
  getters,
  actions: {
    evaluateFederationRestrictions(store, whitelist) {
      return store.commit('evaluateFederationRestrictions', whitelist)
    },
    fetchFederationRestrictions(store) {
      const getFederationRestrictions = async () => {
        const all = await fetchFederationRestrictions()

        const restrictions = {}

        const whitelist =
          useMergedConfigStore().mergedConfig.muteFederationRestrictions
            .whitelist

        for (const e of all) {
          const list = restrictions[e.instance] || []
          restrictions[e.instance] = list
          e.active = evaluate(e, whitelist)
          list.push(e)
        }

        for (const k in restrictions) {
          restrictions[k].sort(comparator)
        }

        return restrictions
      }

      return getFederationRestrictions().then((restrictions) => {
        store.commit('setFederationRestrictions', restrictions)
      })
    },
    startFetchingFederationRestrictions(store) {
      if (store.state.fetchFederationRestrictionsTimer) {
        return
      }

      const interval = setInterval(
        () => store.dispatch('fetchFederationRestrictions'),
        FETCH_FEDERATION_RESTRICTIONS_INTERVAL_MS,
      )
      store.commit('setFetchFederationRestrictionsTimer', interval)

      return store.dispatch('fetchFederationRestrictions')
    },
    stopFetchingFederationRestrictions(store) {
      const interval = store.state.fetchFederationRestrictionsTimer
      store.commit('setFetchFederationRestrictionsTimer', undefined)
      clearInterval(interval)
    },
  },
}

export default federationRestrictions
